import { createBrowserHistory } from 'history'

export var history = createBrowserHistory()

export const createHistory = () => {
  // history = createBrowserHistory()
  return history
}
